module.exports = __webpack_public_path__ + "static/media/fire.26f6cb71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/welcome-bonus/fire.svg
// module id = 2473
// module chunks = 7